import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfileMenu from "./ProfileMenu";
import packageJson from "../../../package.json";
import { Wifi, WifiOff } from "lucide-react";
import UseOnlineStatus from "../../common/UseOnlineStatus";

const Topbar = ({ profile }) => {
  const isSystemOnline = UseOnlineStatus();
  const navigate = useNavigate();

  return (
    <div className="flex justify-end items-center">
      {/* <h1 className="text-2xl font-caveat text-white">Dashboard</h1> */}
      <div className="flex gap-4 items-center space-x-4">
        <div
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full shadow-sm transition-all duration-500 ease-out ${
            isSystemOnline
              ? "bg-emerald-500 text-white"
              : "bg-red-500 text-white"
          }`}
        >
          <span
            className={`w-1.5 h-1.5 rounded-full bg-white ${
              isSystemOnline ? "" : "animate-pulse"
            }`}
          />
          <span className="text-xs font-medium">
            {isSystemOnline ? "Online" : "Offline"}
          </span>
        </div>
        {/* Click to open User Profile */}
        <span
          // onClick={() => navigate("/profile")}
          className="text-sm font-semibold text-white cursor-pointer hover:underline"
        >
          {profile?.name || "User"}
        </span>
        <span className="text-sm text-white font-semibold text-gray-600">
          {"v" + packageJson?.version}
        </span>

        <ProfileMenu />
      </div>
    </div>
  );
};

export default Topbar;
